/* eslint-disable react/jsx-key */
// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import { Route } from 'react-router-dom';

import Products from 'common/enums/Product';

import { Title } from 'common/components/common';
import withRouteTracker from 'common/middleware/RouteTracker';
import { Loader } from 'common/components/core/loader/Loader';
import {
    IntelliSortHeader,
    TerritoryPlanningHeader,
    EntityMgmtHeader
} from 'common/containers/AppHeaderContainer';
import IntelliSortContainer from 'common/containers/intellisort/IntelliSortContainer';
import TerritoryPlanningContainer from 'common/components/territory/TerritoryPlanningContainer';

import {
    withRoutePermissionCheck,
    RoleOperationEnum
} from 'common/modules/rbac';

import SectionWrap from 'common/components/common/SectionWrap';

import { type GetRoutesFn } from './types';

const TrackedIntelliSortSection = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="intelliSortDashboard" />
                <IntelliSortHeader {...props} />
                <IntelliSortContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.INTELLISORT
);

const TrackedTerritoryPlanning = withRouteTracker(
    translate()(props => {
        return (
            <SectionWrap>
                <Title i18nKey="territoryPlanning" />
                <TerritoryPlanningHeader {...props} />
                <TerritoryPlanningContainer {...props} />
            </SectionWrap>
        );
    }),
    Products.FIELD_PRO
);

const FpPlanDetailsContainer = React.lazy(() =>
    import(
        /* webpackChunkName: "field_pro" */
        /* webpackPrefecth: true */ 'common/entity/pjpMaster/planView/FpPlanDetailsContainer'
    )
);

const TrackedFpPlanDetailsSection = withRouteTracker(
    withRoutePermissionCheck(
        translate()(({ ...rest }) => {
            return (
                <React.Suspense fallback={<Loader active />}>
                    <FpPlanDetailsContainer {...rest} />
                </React.Suspense>
            );
        }),
        RoleOperationEnum.VIEW_PJPS
    ),
    Products.FIELD_PRO
);

const PjpMasterContainer = React.lazy(() =>
    import(
        /* webpackChunkName: "field_pro" */
        /* webpackPrefecth: true */ 'common/entity/pjpMaster/PjpMasterContainer'
    )
);

const TrackedPjpMasterContainer = withRouteTracker(
    withRoutePermissionCheck(({ ...rest }) => {
        return (
            <SectionWrap>
                <Title i18nKey="fieldPro" />
                <EntityMgmtHeader {...rest} />
                <React.Suspense fallback={<Loader active />}>
                    <PjpMasterContainer {...rest} />
                </React.Suspense>
            </SectionWrap>
        );
    }, RoleOperationEnum.VIEW_PJPS),
    Products.FIELD_PRO
);

const getRoutes: GetRoutesFn = ({ match, visibleSections }) => {
    return [
        /* Permanent Journey Planner */
        visibleSections.showPjpSection && (
            <Route
                path={`${match.path}/pjp/:pjpId/fpPlan`}
                component={TrackedFpPlanDetailsSection}
            />
        ),
        visibleSections.showPjpSection && (
            <Route
                path={`${match.path}/pjp`}
                component={TrackedPjpMasterContainer}
            />
        ),

        /* IntelliSort */
        visibleSections.showAutosortLiveViewSection && (
            <Route
                path={`${match.path}/intellisort`}
                component={TrackedIntelliSortSection}
            />
        ),
        <Route
            path={`${match.path}/territoryPlanning`}
            component={TrackedTerritoryPlanning}
        />
    ].filter(Boolean);
};

export default getRoutes;
